var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-3 text-xs-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#493cb7"}}),_c('div',{staticClass:"modal-title py-3"},[_vm._v(_vm._s(_vm.$tc(_vm.msgModal)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }